import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import useDecode from "hooks/useDecode";
import useGetEconomicSheets from "services/recordSheets/useGetEconomicSheets";
import LoaderMin from "components/blocks/Loader/LoaderMin";
import { SheetPage, SheetHero, SheetPill, SheetSection, SheetGrid, SheetField, SheetHighlightRow, SheetHighlight, formatText, formatDate, formatCurrency } from "../SheetLayout";

const ReposicionOrtoprotesica: React.FC = () => {
  const params = useParams<{ detailId: string; id: string }>();
  const reposicionOrtoprotesicaId = params.detailId?.split("__")[1];
  const prestacionId = params.id.split("_")[1];
  const { getOrthoprostheticReplacement, dataEconomicSheet: d, loadingEconomicSheet, errorEconomicSheet } = useGetEconomicSheets();
  const userId = useDecode("token")?.extension_id;

  useEffect(() => { getOrthoprostheticReplacement(userId, prestacionId, reposicionOrtoprotesicaId); }, []);

  if (loadingEconomicSheet) return <section className="container"><LoaderMin /></section>;
  if (errorEconomicSheet) return <section className="container"><p className="loader-text">Lo sentimos, se ha producido un error.</p></section>;
  if (!d) return <section className="container"><p className="loader-text">No hay datos para mostrar.</p></section>;

  return (
    <SheetPage>
      <SheetHero
        title="Reposición Ortoprotésica"
        icon="tool"
        pills={<>
          <SheetPill label="Estado" value={formatText(d.estadoSolicitud)} />
          <SheetPill label="Componente" value={formatText(d.tipoComponenteDescripcion)} />
        </>}
      />

      <SheetSection title="Solicitud" icon="file-text">
        <SheetGrid>
          <SheetField label="Fecha Solicitud"                       value={formatDate(d.fechaSolicitud)} />
          <SheetField label="Fecha Aprobación"                      value={formatDate(d.fechaAprobacion)} />
          <SheetField label="Estado Solicitud"                      value={formatText(d.estadoSolicitud)} />
          <SheetField label="Tipo Componente Ortoprotésico"         value={formatText(d.tipoComponenteOrtoprotesico)} />
          <SheetField label="Descripción Componente Ortoprotésico"  value={formatText(d.tipoComponenteDescripcion)} wide />
        </SheetGrid>
      </SheetSection>

      <SheetSection title="Reposición" icon="euro">
        <SheetGrid cols={3}>
          <SheetField label="Fecha Pago/Ingreso"  value={formatDate(d.fechaPago)} />
          <SheetField label="% de Retención"      value={formatText(d.retencion)} />
        </SheetGrid>

        <SheetHighlightRow>
          <SheetHighlight label="Importe Bruto"  value={formatCurrency(d.importe)}     variant="blue" />
          <SheetHighlight label="Importe Neto"   value={formatCurrency(d.importeNeto)} variant="green" />
        </SheetHighlightRow>
      </SheetSection>
    </SheetPage>
  );
};

export default ReposicionOrtoprotesica;
